module.exports = __webpack_public_path__ + "assets/img/00121.f8b02c65.png";